import React, { useState } from 'react'
import { useField } from 'react-final-form'
import AddressQualification from '../AddressQualification'
import * as Styled from '../Form.styles'

const AddressSelect = ({
  name,
  type,
  label,
  smartyStreetsWebsiteKey,
  placeholderText = null,
  validations = null,
  ...rest
}) => {
  const [addressQual] = useState(
    new AddressQualification({
      smartyStreetsWebsiteKey,
    })
  )

  const { input, meta } = useField(name, {
    validate: validations,
  })

  return (
    <Styled.Label gridArea={name}>
      <Styled.LabelText className="label input-label">{label}</Styled.LabelText>
      <Styled.AddressSelect
        {...input}
        {...rest}
        cacheOptions
        defaultOptions
        loadOptions={
          (inputValue) =>
            addressQual
              .autofillSuggestions(inputValue)
              .catch((err) => console.error(err)) // eslint-disable-line
        }
        placeholder={placeholderText}
        isClearable
        isTouchedAndValid={Boolean(meta.touched && !meta.error)}
        hasError={Boolean(meta.touched && meta.error)}
        aria-invalid={Boolean(meta.touched && meta.error)}
        styles={{
          // Fixes the overlapping problem of the component
          // This method comes straight from their docs
          menu: (provided) => ({
            ...provided,
            zIndex: 26,
          }),
        }}
      />
      {meta.error && meta.touched && (
        <Styled.ErrorText className="error-text">{meta.error}</Styled.ErrorText>
      )}
    </Styled.Label>
  )
}

export default AddressSelect
